// @ts-ignore
if (!global._babelPolyfill) {
    require('babel-polyfill');
}
import OpenTicketShop from './shop';
import OpenTicketOrder from './order';
window.OpenTicket = Object.assign(window.OpenTicket || {}, {
    createShop() {
        return new OpenTicketShop();
    },
    createOrder() {
        return new OpenTicketOrder();
    },
});
export { OpenTicketShop, OpenTicketOrder };
export * from './shop';
export * from './order';
import Cart from './cart';
export { Cart };
export * from './cart';
import OpenTicketBase from './internals';
export { OpenTicketBase };
export * from './internals';
import CrossWindowBase from './messaging';
export { CrossWindowBase };
export * from './messaging';
export * from './integrations';
export * from './utils';
//# sourceMappingURL=index.js.map